import axiosInstance from './axiosInstance';
import { APIParkReport, APIParkReportsResponse } from '../../types';
import { CancelToken } from 'axios';

interface GetReportsParams {
  sport: string;
  areaId: string;
  pageCursor?: string;
  cancelToken?: CancelToken;
}

interface PostReportParams {
  sport: string;
  areaId: string;
  reportText: string;
  date?: number;
}

interface PostPhotoParams {
  sport: string;
  areaId: string;
  reportId: string;
  base64File: string;
}

interface GetSingleParams {
  sport: string;
  reportId: string;
}

const parkReport = {
  // Get all park reports for an area
  getReports: async ({ sport, areaId, pageCursor, cancelToken }: GetReportsParams): Promise<APIParkReportsResponse> => {
    let url = `/${sport}/reports`;
    // add query parameters
    const queryParameters = [`area=${areaId}`];

    if (pageCursor) {
      queryParameters.push(`ExclusiveStartKey=${pageCursor}`);
    }
    if (queryParameters && queryParameters.length) {
      url += `?${queryParameters.join('&')}`;
    }

    const response = await axiosInstance.get(url, { cancelToken });
    return response.data || {};
  },

  // Post a new park report
  post: async ({ sport, areaId, reportText, date }: PostReportParams): Promise<APIParkReport> => {
    const url = `/${sport}/areas/${areaId}/reports`;
    const body = {
      date: date || Date.now(),
      reportText: reportText.trim(),
      stars: 5, // Legacy field, keeping for compatibility
    };

    const response = await axiosInstance.post(url, body);
    return response.data;
  },

  // Post a photo for a park report
  postPhoto: async ({ sport, areaId, reportId, base64File }: PostPhotoParams): Promise<any> => {
    const url = `/${sport}/areas/${areaId}/reports/${reportId}/photos`;
    const body = {
      base64File,
    };

    const response = await axiosInstance.post(url, body);
    return response.data;
  },

  // Get a single park report
  getSingle: async ({ sport, reportId }: GetSingleParams): Promise<APIParkReport> => {
    const url = `/${sport}/reports/${reportId}`;
    const response = await axiosInstance.get(url);
    return response.data;
  },
};

export default parkReport;
